// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ld","subtitle":"md","contentWrap":"nd","imgWrap":"od","heading":"pd","copy":"qd"};